import { useMemo } from 'react';
import { useDebouncedCallback, useFilterChangeCallback, useRuntimeSetting } from 'shared/hooks';
import { FILTER_KEY } from '../constants';

export const usePriceChangeHandler = () => {
  const onChange = useFilterChangeCallback(FILTER_KEY);

  const debounceDelay = useRuntimeSetting<number>('desktopFiltersMicrofrontend.inputDebounceDelay', 1000);

  const onPriceMinChange = useDebouncedCallback((gte: number | null) => {
    onChange({ action: 'setPriceMin', arguments: [gte] });
  }, debounceDelay);

  const onPriceMaxChange = useDebouncedCallback((lte: number | null) => {
    onChange({ action: 'setPriceMax', arguments: [lte] });
  }, debounceDelay);

  return useMemo(
    () => ({
      onChangeMin: onPriceMinChange,
      onChangeMax: onPriceMaxChange,
    }),
    [onPriceMaxChange, onPriceMinChange],
  );
};
